import {GlobalAxios} from "../axios/axios-config";

const FILE_MANAGER_ROUTE = process.env.REACT_APP_FILEMANAGER;

export const signFile = (filePath: string) => {
    const formData = new FormData()
    formData.append("FilePath", filePath)

    return GlobalAxios.post(`${FILE_MANAGER_ROUTE}/api/v1/Signed`, formData);
}